import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

@Component({ className: 'js-header' })
export class NavigationHideScrollDownShowScrollUpComponent {
	private _wrapperElement: HTMLElement;
	private _lastScrollTop = 0;
	private _threshold = 10;
	private _navHeight = 0;
	private _bodyElement: HTMLElement;
	private _direction = '';

	constructor(private element: HTMLElement) {
		this._wrapperElement = element;
		this._bodyElement = document.body;
		this.init();
	}

	private init() {
		window.addEventListener('scroll', () => this.handleScroll());
	}

	handleScroll() {
		if (window.pageYOffset === 0) {
			removeClass(this._bodyElement, 'going-up');
			addClass(this._bodyElement, 'going-down');
		} else {
			const currentYOffset = window.pageYOffset;
			if (
				currentYOffset > this._lastScrollTop &&
				currentYOffset > 0 &&
				currentYOffset - this._lastScrollTop >= this._threshold
			) {
				this._direction = 'down';
				removeClass(this._bodyElement, 'going-up');
				addClass(this._bodyElement, 'going-down');
			} else if (
				currentYOffset < this._lastScrollTop &&
				this._lastScrollTop - currentYOffset >= this._threshold
			) {
				this._direction = 'up';
				addClass(this._bodyElement, 'going-up');
				removeClass(this._bodyElement, 'going-down');
			}
			this._lastScrollTop = currentYOffset;
		}
	}
}
